__turbopack_context__.v({
  "root": "PlasmicSliderThumb-module__MuhsOW__root",
});
